/**
 * USMAN Initialization Middleware
 * Ensures USMAN permissions are loaded before accessing protected routes
 */

export default async function usmanInit({ store, redirect, route, $auth }) {
  // Skip if user is not authenticated
  if (!$auth.loggedIn) {
    return
  }

  // Set user role in USMAN store
  if ($auth.user && $auth.user.role) {
    store.commit('usman/SET_USER_ROLE', $auth.user.role)
  }

  // Skip if already initialized or currently loading
  const isInitialized = store.state.usman.isInitialized
  const isLoading = store.state.usman.isLoading

  if (isInitialized || isLoading) {
    return
  }

  try {
    // Load USMAN configuration
    await store.dispatch('usman/fetchUsmanConfig')
  } catch (error) {
    // If USMAN loading fails, disable it and continue
    store.commit('usman/SET_USE_USMAN_PERMISSIONS', false)

    // Optional: Log error for debugging
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('USMAN initialization failed:', error)
    }
  }
}
